<template>
  <div>
    <!-- 查询条件 -->
    <b-row class="mt-5 mb-2 ml-2 font" >
     
     <b-col cols="2"  > 当前纳税所属期： </b-col>

      <b-col cols="8">
       <span class="bold"> {{ item.period }} </span>
        
        <b-link class="ml-3" style="text-decoration: underline;" @click="openUpdateNowDialog">立即更新</b-link>
      </b-col>
    </b-row>

    <b-row  class="mt-4 mb-2 ml-2 font" >
     
     <b-col cols="2"  > 销售税额： </b-col>
     <b-col class="bold" style="font-size:2rem;"> {{ item.saleTaxAmount }} </b-col>

    </b-row>

    <b-row  class="mt-4 mb-2 ml-2 font" >
     
     <b-col cols="2"  > 可抵扣税额： </b-col>
     <b-col class="bold" style="font-size:2rem;"> {{ item.deductTaxAmount }} </b-col>

    </b-row>

    <b-row  class="mt-4 mb-2 ml-2 font" >
     
     <b-col cols="10"  > 税负分析：<span v-if="showErrorAnalysis">你的抵扣额度不足，预计缴纳税款{{ item.diffTaxAmount }}元</span> 
      <span v-if="showSuccessAnalysis">你的抵扣额度充足，预计缴纳税款0元</span>
    </b-col>

    </b-row>
    <b-row  class="mb-2 ml-2" v-if="showErrorAnalysis">
     
     <b-col cols="10"  > 如需进行税收筹划协助，请<b-link style="text-decoration: underline;" @click="openAddDialog">提报需求</b-link> </b-col>

    </b-row>


    <b-modal id="addModal" title="需求提报" incline v-model="addDialogVisible" @ok="handleAdd">
      <template slot="modal-ok">确定</template>
      <template slot="modal-cancel">取消</template>
      <validation-observer ref="addForm">
        <form>
          <validation-provider
            :rules="validators.rules.contactName"
            :customMessages="validators.msgs.contactName"
            name="您的姓名"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              :invalid-feedback="validationContext.errors[0]"
            >
              <template slot="label">
                <span class="text-danger">*</span>您的姓名:
              </template>
              <b-form-input
                v-model="addParam.contactName"
                :state="validateState(validationContext)"
                required
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.contactPhone"
            :customMessages="validators.msgs.contactPhone"
            name="联系电话"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              :invalid-feedback="validationContext.errors[0]"
            >
              <template slot="label">
                <span class="text-danger">*</span>联系电话:
              </template>
              <b-form-input
                v-model="addParam.contactPhone"
                :state="validateState(validationContext)"
                required
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.requirements"
            :customMessages="validators.msgs.requirements"
            name="需求"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="3"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>需求:
              </template>
              <b-form-checkbox-group
                 class="mt-2"
                v-model="addParam.requirements"
                :options="requirements"
                :state="validateState(validationContext)"
              ></b-form-checkbox-group>
            </b-form-group>
          </validation-provider>

          <validation-provider
            :rules="validators.rules.description"
            :customMessages="validators.msgs.description"
            name="说明"
            v-slot="validationContext"
          >
            <b-form-group
            
              label-cols-sm="3"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger"></span>说明:
              </template>
              <b-form-textarea v-model="addParam.description" rows="3" max-rows="6" no-resize></b-form-textarea>
            </b-form-group>
          </validation-provider>
        </form>
      </validation-observer>
    </b-modal>


    <b-modal
      id="invUploadDialog"
      title="发票数据汇总"
      incline
      v-model="loginDialogVisible"
      
      ok-only
    >
      <template slot="modal-ok">确定</template>
       
        <div style="text-align:center;">
          <img :src="qrText"  style="width:200px;"       
          ></img>

        </div>

        <div>
            
               <p style="margin-bottom:2px;">拥有电子税局身份的用户，通过电子税局app扫描二维码后，系统将自动上报上月发票数据 </p>
                <p> 二维码的有效期为100秒</p>
               
          
          <p>
            登录成功之后，任务会自动开始，并且自动结束
          </p>
        </div>

    </b-modal>

    <loading :show="pageLoading"></loading>
   
  </div>
</template>

<script>

import * as entReqFacade from "@/api/tcs-ent-req-facade.js";
import * as entTaxFacade from "@/api/tcs-ent-tax-facade.js";

import * as uploadTaskFacade from "@/api/tcs-upload-task-facade.js";

import { mapState } from "vuex";


//import dayjs from "dayjs";

export default {
  // validations:
  data() {
    return {
        item:{
          period:"",
          saleTaxAmount:null,
          deductTaxAmount:null,
          diffTaxAmount:null
        },
        qrText:"",
      
      //上传文件param
      addParam: {
        contactName: "",
        contactPhone:"",
        requirements: [],
        description: "",
      },
      requirements:[{
        text:"融资需求",value:"融资需求"
      },{text:"税收筹划",value:"税收筹划"},
      {text:"其他需求",value:"其他需求"}
    ],

      validators: {
        rules: {
          contactName: {
            required: true,
            max:16
          },
          contactPhone: {
            required: true,
            phone:true
            
          },
          requirements: {
            required: true
          },
          description:{
            max:1000
          }
        },
        msgs: {
          contactName: {
            required: "姓名不能为空"
          },
          contactPhone: {
            required: "联系电话不能为空",
            phone:"联系电话格式不正确"
          },
          requirements: {
            required: "请选择需求"
          },
          description:{
            max:"长度不能超过1000个字符"
          }
        }
      },
     
      // 以下为页面状态控制参数
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      addDialogVisible: false,

      loginDialogVisible: false,

      loginActionFlag:false,
      showSuccessAnalysis:false,//显示成功
      showErrorAnalysis:false,//实现失败
      // 以下为表单校验规则

      // websocket
      sessionId:null,
      websocket: null,
      lockReconnect: false, //是否真正建立连接
      timeout: 30 * 1000, //20秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null //断开 重连倒计时
     
      // 以下为表单校验规则

      // 以上为表单校验规则
    };
  },

  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    //this.initInfo();
  },
  mounted() {
    // 异步加载列表数据

    //this.handleQuery();
    this.list();

    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    
    // 异步加载列表数据
    list(page) {
     
      this.pageLoading = true; // 打开表格的Loading状态
      entTaxFacade
        .obtain() // 异步调用后台接口
        .then(res => {
          this.item = res; // 为表格填充数据
          this.pageLoading = false; // 关闭表格的Loading状态
          if(res.diffTaxAmount){

            if(res.diffTaxAmount>0){
                 this.showErrorAnalysis=true;
            }else{
                 this.showSucessAnalysis=true;
            }
          }
         
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    openAddDialog() {
      this.addDialogVisible = true;
      this.$nextTick(() => {
        Object.assign(this.$data.addParam, this.$options.data().addParam);
      });
    },
   //添加需求
    handleAdd(e) {
      e.preventDefault();

      //this.nameState = this.$refs.form.checkValidity();
      this.$refs.addForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.pageLoading = true;
        entReqFacade
          .add(this.addParam)
          /* eslint-disable */
          .then(res => {
            this.pageLoading = false;
            this.addDialogVisible = false;
            this.$message({
              message: "需求提报成功",
              type: "success"
            });
          
          })
          .catch(err => {
            this.pageLoading = false;
            console.log("err", err);
          });
      });
    },

    //打开立即更新
    openUpdateNowDialog() {
      this.loginActionFlag=true;
      this.initWebSocket();
      this.pageLoading=true;
     
    },

     //获取登录二维码
     getLoginCode(item,sessionId){
      let param={
        //'taskId':item.id,
        'type':'2',
        'sessionId':sessionId
      }
      uploadTaskFacade.getLoginCode(param).then(()=>{
          
            //this.loginDialogVisible=true;  

       }).catch(e=>{
        this.pageLoading=false;
       });
    },

    //执行任务
    executeTask(){
      var nsrsbh=this.item.entCode;
      this.pageLoading=true;
      entTaxFacade.executeTask(nsrsbh).then(res=>{
         //执行一遍查询
         this.$message({
          type:'success',
          message:"操作成功"
         })
          this.list();
           this.pageLoading=false;
      });

    },

    

    //socket相关

    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 60000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start() {
      //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息
        if (self.websock.readyState == 1) {
          //如果连接正常
          let wsCommandDto = {}
          wsCommandDto.sessionId = sessionId;
          wsCommandDto.commandId = "heart";
          wsCommandDto.message = "heart"
           
          self.websock.send(JSON.stringify(wsCommandDto));
        } else {
          //否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function () {
          //超时关闭
          self.websock.close();
        }, self.timeout);
      }, self.timeout);
    },
    //初始化weosocket 
    async initWebSocket() { 
      const wsuri = process.env.VUE_APP_WEBSOCKET_ROOT_PATH + "/eids-invoice/ws/camera";//ws地址
      console.log("正在连接ws: " + wsuri)
      this.websock = new WebSocket(wsuri); 
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage; 
      this.websock.onclose = this.websocketclose;
    }, 

    websocketonopen() {
      console.log("WebSocket连接成功");
      // 成功后，告诉对方我已经连接成功
     
   
      // let wsCommandDto = {}
      // wsCommandDto.sessionId = this.sessionId;
      // wsCommandDto.commandId = "taskLogin";
      // wsCommandDto.message = "登录任务已经连接成功"
      // this.websocketsend(JSON.stringify(wsCommandDto))
    },
    websocketonerror(e) { //错误
      console.log("WebSocket连接发生错误:" + e);
      if(this.loginActionFlag){
      this.reconnect();
      }
    },
    websocketonmessage(e) { //数据接收 
     
      var res=JSON.parse(e.data);
     
      if(res.commandId&&res.commandId=='sendSessionId'){
         this.sessionId=res.sessionId;
         //获取登录二维码
         this.getLoginCode(null,this.sessionId);
       
      }else{
      console.log(res);
      var success=res.success;
      var code = res.code;
      if(!success){
        this.$message({
            message: res.msg,
            type: "danger"
         });
         return;
      }
      //显示人脸识别二维码
      if("QRCODE"==code){
        this.pageLoading=false;
        this.loginDialogVisible=false;
         this.qrText=res.data; 
         this.loginDialogVisible=true;
       
      }
      //登录成功
      if("S000"==code){
         //登录成功处理发票汇总任务
         //this.pageLoading=false;
         this.executeTask();
      }
    }


    }, 

    websocketsend(data) {//数据发送 
      this.websock.send(data); 
    }, 
    websocketclose(e) { //关闭 
        // 向发票审核页面发送退出的命令
        // let wsCommandDto = {}
        // wsCommandDto.sessionId = this.sessionId;
        // wsCommandDto.commandId = "mobileDisconnected";
        // wsCommandDto.message = "已退出"
        // this.websocketsend(JSON.stringify(wsCommandDto))
        if(this.loginActionFlag){
            this.reconnect();
        }
        console.log("connection closed (" + e + ")"); 
    },

  }
};
</script>

<style >
.bold{
  font-weight:bold;
}
.font{
  line-height: 3rem;
  height:3rem;
}
</style>
